import React, { useState } from 'react';
import { toast } from 'sonner';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const Newsletter = () => {
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!email || !email.includes('@')) {
      toast.error('Please enter a valid email address');
      return;
    }

    setIsSubmitting(true);
    
    try {
      // Pull ?ref=CODE from URL (and remember it for ~30 days so it survives navigation)
      let refCode = '';
      try {
        const params = new URLSearchParams(window.location.search);
        refCode = params.get('ref') || localStorage.getItem('referral_code') || '';
        if (params.get('ref')) localStorage.setItem('referral_code', params.get('ref'));
      } catch {}

      const response = await axios.post(`${API_URL}/api/newsletter/subscribe`, {
        email: email,
        source: 'footer_newsletter',
        ref_code: refCode || undefined,
      });
      
      // Persist subscription so gated content (Learn) unlocks across the site
      try { localStorage.setItem('subscriber_email', email); } catch {}
      window.dispatchEvent(new CustomEvent('subscriber-changed', { detail: { email } }));

      toast.success(response.data.message || 'Successfully subscribed!');
      setEmail('');
    } catch (error) {
      console.error('Newsletter subscription error:', error);
      toast.error(error.response?.data?.detail || 'Failed to subscribe. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="max-w-2xl mx-auto text-center">
      <h3 className="text-3xl font-light mb-4">Stay Updated</h3>
      <p className="text-gray-600 mb-8">
        Get notified when I publish new articles on AI ethics and technology.
        No spam, unsubscribe anytime.
      </p>
      
      <form onSubmit={handleSubmit} className="flex flex-col sm:flex-row gap-4 max-w-md mx-auto" data-testid="newsletter-form">
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="Enter your email"
          className="flex-1 px-6 py-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-black focus:border-transparent"
          disabled={isSubmitting}
          data-testid="newsletter-email-input"
        />
        <button
          type="submit"
          disabled={isSubmitting}
          className="px-8 py-3 bg-black text-white rounded-md hover:bg-gray-800 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
          data-testid="newsletter-submit-btn"
        >
          {isSubmitting ? 'Subscribing...' : 'Subscribe'}
        </button>
      </form>
    </div>
  );
};

export default Newsletter;
